var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined, } from '@ant-design/icons';
import { isVoidField } from '@formily/core';
import { connect, mapProps } from '@formily/react';
import { Popover, Tooltip } from 'antd';
import cls from 'classnames';
import React, { useState } from 'react';
import { FormLayoutShallowContext } from '../form-layout';
import { pickDataProps, usePrefixCls } from '../__builtins__';
import { useFormItemLayout, useOverflow } from './hooks';
import useStyle from './style';
export * from './hooks';
export * from './types';
var ICON_MAP = {
    error: React.createElement(CloseCircleOutlined, null),
    success: React.createElement(CheckCircleOutlined, null),
    warning: React.createElement(ExclamationCircleOutlined, null),
};
export var BaseItem = function (_a) {
    var _b, _c, _d, _e, _f;
    var children = _a.children, props = __rest(_a, ["children"]);
    var _g = __read(useState(false), 2), active = _g[0], setActive = _g[1];
    var formLayout = useFormItemLayout(props);
    var _h = useOverflow(), containerRef = _h.containerRef, contentRef = _h.contentRef, overflow = _h.overflow;
    var label = formLayout.label, style = formLayout.style, layout = formLayout.layout, _j = formLayout.colon, colon = _j === void 0 ? true : _j, addonBefore = formLayout.addonBefore, addonAfter = formLayout.addonAfter, asterisk = formLayout.asterisk, feedbackStatus = formLayout.feedbackStatus, extra = formLayout.extra, feedbackText = formLayout.feedbackText, fullness = formLayout.fullness, feedbackLayout = formLayout.feedbackLayout, feedbackIcon = formLayout.feedbackIcon, getPopupContainer = formLayout.getPopupContainer, inset = formLayout.inset, _k = formLayout.bordered, bordered = _k === void 0 ? true : _k, labelWidth = formLayout.labelWidth, wrapperWidth = formLayout.wrapperWidth, labelCol = formLayout.labelCol, wrapperCol = formLayout.wrapperCol, labelAlign = formLayout.labelAlign, _l = formLayout.wrapperAlign, wrapperAlign = _l === void 0 ? 'left' : _l, size = formLayout.size, labelWrap = formLayout.labelWrap, wrapperWrap = formLayout.wrapperWrap, tooltipLayout = formLayout.tooltipLayout, tooltip = formLayout.tooltip, tooltipIcon = formLayout.tooltipIcon;
    var labelStyle = __assign({}, formLayout.labelStyle);
    var wrapperStyle = __assign({}, formLayout.wrapperStyle);
    var prefixCls = usePrefixCls('formily-item', props);
    var _m = __read(useStyle(prefixCls), 2), wrapSSR = _m[0], hashId = _m[1];
    // 固定宽度
    var enableCol = false;
    if (labelWidth || wrapperWidth) {
        if (labelWidth) {
            labelStyle.width = labelWidth === 'auto' ? undefined : labelWidth;
            labelStyle.maxWidth = labelWidth === 'auto' ? undefined : labelWidth;
        }
        if (wrapperWidth) {
            wrapperStyle.width = wrapperWidth === 'auto' ? undefined : wrapperWidth;
            wrapperStyle.maxWidth = wrapperWidth === 'auto' ? undefined : wrapperWidth;
        }
        // 栅格模式
    }
    if (labelCol || wrapperCol) {
        if (!labelStyle.width && !wrapperStyle.width && layout !== 'vertical') {
            enableCol = true;
        }
    }
    var formatChildren = feedbackLayout === 'popover' ? (React.createElement(Popover, { autoAdjustOverflow: true, overlayClassName: "".concat(prefixCls, "-popover"), placement: "top", content: React.createElement("div", { className: cls((_b = {},
                _b["".concat(prefixCls, "-").concat(feedbackStatus, "-help")] = !!feedbackStatus,
                _b["".concat(prefixCls, "-help")] = true,
                _b)) },
            feedbackStatus ? ICON_MAP[feedbackStatus] : null,
            " ",
            feedbackText), open: !!feedbackText, getPopupContainer: getPopupContainer },
        React.createElement(React.Fragment, null, children))) : (children);
    var gridStyles = {};
    var getOverflowTooltip = function () {
        if (overflow) {
            return (React.createElement("div", null,
                React.createElement("div", null, label),
                React.createElement("div", null, tooltip)));
        }
        return tooltip;
    };
    var renderLabelText = function () {
        var labelChildren = (React.createElement("div", { className: "".concat(prefixCls, "-label-content"), ref: containerRef },
            React.createElement("span", { ref: contentRef },
                asterisk && React.createElement("span", { className: "".concat(prefixCls, "-asterisk") }, '*'),
                React.createElement("label", null, label))));
        if ((tooltipLayout === 'text' && tooltip) || overflow) {
            return (React.createElement(Tooltip, { placement: "top", title: getOverflowTooltip() }, labelChildren));
        }
        return labelChildren;
    };
    var renderTooltipIcon = function () {
        if (tooltip && tooltipLayout === 'icon' && !overflow) {
            return (React.createElement("span", { className: "".concat(prefixCls, "-label-tooltip-icon") },
                React.createElement(Tooltip, { placement: "top", title: tooltip }, tooltipIcon)));
        }
    };
    var renderLabel = function () {
        var _a;
        if (!label)
            return null;
        return (React.createElement("div", { className: cls((_a = {},
                _a["".concat(prefixCls, "-label")] = true,
                _a["".concat(prefixCls, "-label-tooltip")] = (tooltip && tooltipLayout === 'text') || overflow,
                _a["".concat(prefixCls, "-item-col-").concat(labelCol)] = enableCol && !!labelCol,
                _a)), style: labelStyle },
            renderLabelText(),
            renderTooltipIcon(),
            label !== ' ' && (React.createElement("span", { className: "".concat(prefixCls, "-colon") }, colon ? ':' : ''))));
    };
    return wrapSSR(React.createElement("div", __assign({}, pickDataProps(props), { style: __assign(__assign({}, style), gridStyles), "data-grid-span": props.gridSpan, className: cls(props.className, (_c = {},
            _c["".concat(prefixCls)] = true,
            _c["".concat(prefixCls, "-layout-").concat(layout)] = true,
            _c["".concat(prefixCls, "-").concat(feedbackStatus)] = !!feedbackStatus,
            _c["".concat(prefixCls, "-feedback-has-text")] = !!feedbackText,
            _c["".concat(prefixCls, "-size-").concat(size)] = !!size,
            _c["".concat(prefixCls, "-feedback-layout-").concat(feedbackLayout)] = !!feedbackLayout,
            _c["".concat(prefixCls, "-fullness")] = !!fullness || !!inset || !!feedbackIcon,
            _c["".concat(prefixCls, "-inset")] = !!inset,
            _c["".concat(prefixCls, "-active")] = active,
            _c["".concat(prefixCls, "-inset-active")] = !!inset && active,
            _c["".concat(prefixCls, "-label-align-").concat(labelAlign)] = true,
            _c["".concat(prefixCls, "-control-align-").concat(wrapperAlign)] = true,
            _c["".concat(prefixCls, "-label-wrap")] = !!labelWrap,
            _c["".concat(prefixCls, "-control-wrap")] = !!wrapperWrap,
            _c["".concat(prefixCls, "-bordered-none")] = bordered === false || !!inset || !!feedbackIcon,
            _c), hashId), onFocus: function () {
            if (feedbackIcon || inset) {
                setActive(true);
            }
        }, onBlur: function () {
            if (feedbackIcon || inset) {
                setActive(false);
            }
        } }),
        renderLabel(),
        React.createElement("div", { className: cls((_d = {},
                _d["".concat(prefixCls, "-control")] = true,
                _d["".concat(prefixCls, "-item-col-").concat(wrapperCol)] = enableCol && !!wrapperCol && label,
                _d)) },
            React.createElement("div", { className: cls("".concat(prefixCls, "-control-content")) },
                addonBefore && (React.createElement("div", { className: cls("".concat(prefixCls, "-addon-before")) }, addonBefore)),
                React.createElement("div", { style: wrapperStyle, className: cls((_e = {},
                        _e["".concat(prefixCls, "-control-content-component")] = true,
                        _e["".concat(prefixCls, "-control-content-component-has-feedback-icon")] = !!feedbackIcon,
                        _e)) },
                    React.createElement(FormLayoutShallowContext.Provider, { value: {} }, formatChildren),
                    feedbackIcon && (React.createElement("div", { className: cls("".concat(prefixCls, "-feedback-icon")) }, feedbackIcon))),
                addonAfter && (React.createElement("div", { className: cls("".concat(prefixCls, "-addon-after")) }, addonAfter))),
            !!feedbackText &&
                feedbackLayout !== 'popover' &&
                feedbackLayout !== 'none' && (React.createElement("div", { className: cls((_f = {},
                    _f["".concat(prefixCls, "-").concat(feedbackStatus, "-help")] = !!feedbackStatus,
                    _f["".concat(prefixCls, "-help")] = true,
                    _f["".concat(prefixCls, "-help-enter")] = true,
                    _f["".concat(prefixCls, "-help-enter-active")] = true,
                    _f)) }, feedbackText)),
            extra && React.createElement("div", { className: cls("".concat(prefixCls, "-extra")) }, extra))));
};
// 适配
export var FormItem = Object.assign(connect(BaseItem, mapProps(function (props, field) {
    if (isVoidField(field))
        return {
            label: field.title || props.label,
            asterisk: props.asterisk,
            extra: props.extra || field.description,
        };
    if (!field)
        return props;
    var takeFeedbackStatus = function () {
        if (field.validating)
            return 'pending';
        return field.decoratorProps.feedbackStatus || field.validateStatus;
    };
    var takeMessage = function () {
        var split = function (messages) {
            return messages.reduce(function (buf, text, index) {
                if (!text)
                    return buf;
                return index < messages.length - 1
                    ? buf.concat([text, ', '])
                    : buf.concat([text]);
            }, []);
        };
        if (field.validating)
            return;
        if (props.feedbackText)
            return props.feedbackText;
        if (field.selfErrors.length)
            return split(field.selfErrors);
        if (field.selfWarnings.length)
            return split(field.selfWarnings);
        if (field.selfSuccesses.length)
            return split(field.selfSuccesses);
    };
    var takeAsterisk = function () {
        if ('asterisk' in props) {
            return props.asterisk;
        }
        if (field.required && field.pattern !== 'readPretty') {
            return true;
        }
        return false;
    };
    return {
        label: props.label || field.title,
        feedbackStatus: takeFeedbackStatus(),
        feedbackText: takeMessage(),
        asterisk: takeAsterisk(),
        extra: props.extra || field.description,
    };
})), {
    BaseItem: BaseItem,
});
export default FormItem;
//# sourceMappingURL=index.js.map